<table class="table" style="background-color:white;">

  <tr>
    <td style="background-color:#0f2b46;color:white;" colspan="2">Update Promo Code</td>
    <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
  </tr>
</table>



<form (ngSubmit)="update(UpdatereferencialCodeForm.value)" [formGroup]="UpdatereferencialCodeForm">

  <div class="container">
    <label>Email Id :</label> &nbsp; <label>{{EmailId}}</label>
    <mat-form-field class="col-lg-4">
      <input matInput placeholder="Promo Code" formControlName="referencialCode" required />
      <mat-error *ngIf="submitted && f.referencialCode.errors">
        Enter Promo Code
      </mat-error>
    </mat-form-field>
    <button mat-raised-button class="col-lg-3" color="primary">Submit</button>
  </div>

</form>






